import { 
    GET_ALL_CATEGORIES_WEB_SYS,
    GET_ALL_CATEGORIES_WEB,
    SET_ERRORS,
    POST_CATEGORY_WEB,
    LOADING_UI,
    STOP_LOADING_UI,
    CLEAR_ERRORS,
    SET_CATEGORY,
    LOADING_CATE,
    UPDATE_CATEGORY_WEB,
    DELETE_CATEGORY_WEB,
    SET_NOTY,
 } from '../types';
import axios from 'axios';

export const clearErrors = () => dispatch => {
    dispatch({ type: CLEAR_ERRORS });
}

/////
export const postCategoryWeb = (newCategory, history) => (dispatch) => {
    dispatch({type: LOADING_UI});
    axios.post('/category-web', newCategory)
        .then(res => {
            dispatch({
                type: POST_CATEGORY_WEB,
                payload: res.data
            });
            dispatch(clearErrors());
            history.push('/ntea-viet-nam/danh-muc');
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response
            })
        })
}
export const getAllCategoriesWebSys = () => dispatch => {
    dispatch({type: LOADING_UI});
    axios.get(`/categories-web/`)
        .then(res => {
            dispatch({
                type: GET_ALL_CATEGORIES_WEB_SYS,
                payload: res.data
            })
            dispatch({ type: STOP_LOADING_UI })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_CATEGORIES_WEB_SYS,
                payload: []
            })
        })
}
export const getAllCategoriesWeb = (domain) => dispatch => {
    dispatch({type: LOADING_UI});
    axios.get(`/categories-web/${domain}`)
        .then(res => {
            dispatch({
                type: GET_ALL_CATEGORIES_WEB,
                payload: res.data
            })
            dispatch({ type: STOP_LOADING_UI })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_CATEGORIES_WEB,
                payload: []
            })
        })
}
export const getCategoryWeb = (categoryId) => (dispatch) => {
    dispatch({type: LOADING_CATE});
    axios
    .get(`/category-web/${categoryId}`)
    .then(res => {
        dispatch({
            type: SET_CATEGORY,
            payload: res.data
        })
    })
    .catch(err => console.log(err));
}

export const updateCategoryWeb = (categoryId, dataCategory) => dispatch => {
  dispatch({type: LOADING_UI});
  axios.post(`/category-web/${categoryId}`, dataCategory)
        .then(res => {
            dispatch({
                type: SET_NOTY,
                payload: res.data.message
            })
        })
        .then(() => {
            dispatch({
                type: UPDATE_CATEGORY_WEB,
                payload: dataCategory,
                categoryId,
            })
      })
      .catch(err => console.log(err));
}

export const deleteCategoryWeb = (categoryId) => dispatch => {
    dispatch({type: LOADING_UI});
    axios.delete(`/category-web/${categoryId}`)
        .then(() => {
            dispatch({
                type: DELETE_CATEGORY_WEB,
                categoryId,
            })
            dispatch({ type: STOP_LOADING_UI })
        })
        .catch(err => console.log(err));
}